import { Injectable } from '@angular/core';

declare var OnetrustActiveGroups; // global var set by One Trust

export enum OneTrustGroups {
  StrictlyNecessary = 'C0001',
  Performance = 'C0002',
  Functional = 'C0003',
  Targeting = 'C0004',
}

@Injectable({ providedIn: 'root' })
export class OneTrustService {
  /**
   * OneTrust creates a global var to check which categories have been consented to.
   * However, it may not have been created by the time the logging is initialized.
   */
  public getOneTrustGroups(i = 0): Promise<OneTrustGroups[]> {
    return new Promise((resolve) => {
      if (typeof OnetrustActiveGroups !== 'undefined') {
        resolve(OnetrustActiveGroups.split(','));
      } else {
        if (i > 4) {
          // give up and assume no consent
          resolve([]);
        }
        setTimeout(() => this.getOneTrustGroups(i + 1), 50); // retry in a bit
      }
    });
  }
}
